import { Publish } from '@mui/icons-material';
import { makeObservable, observable } from 'mobx';
import SituacaoPublicacaoPauta, { SITUACAO_PUBLICACAO_PAUTA } from '../../dominio/SituacaoPublicacaoPauta';
import { Filtro } from './Filtro';

export default class FiltroSituacaoPublicacaoPauta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Situação de publicação';
    }

    getIconeFiltroRapido() {
        return <Publish />;
    }

    opcoesFiltro = FiltroSituacaoPublicacaoPauta.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        const opcoes = [];

        for (const situacao of Object.values(SITUACAO_PUBLICACAO_PAUTA)) {
            const opcao = {
                valor: situacao.id,
                cor: situacao.cor,
                icone: SituacaoPublicacaoPauta.getIcone(situacao.id)
            };

            opcoes.push(opcao);
        }

        return opcoes;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        let situacaoPublicacaoId = registro.materiaPublicacaoPauta?.situacao;

        if (!situacaoPublicacaoId) {
            if (registro.confirmadaPublicacaoPauta) {
                situacaoPublicacaoId = SITUACAO_PUBLICACAO_PAUTA.LIBERADO_PARA_DISPONIBILIZACAO.id;
            }
        }

        if (!situacaoPublicacaoId) {
            return SITUACAO_PUBLICACAO_PAUTA.NAO_LIBERADO_PUBLICACAO.id;
        }

        return situacaoPublicacaoId;
    }

    getDescricao(valor) {
        return SituacaoPublicacaoPauta.getDescricao(valor);
    }
}
